import clsx from "clsx";

export const customTwMerge = (
  ...classes: (string | undefined | false | (string | undefined | false)[])[]
): string => {
  const flattenedClasses = classes.flat();
  const classMap: { [key: string]: string } = {};
  let singleClasses = "";

  const mergedClasses = clsx(...flattenedClasses)
    .split(" ")
    .filter(Boolean);

  mergedClasses.forEach((className: string) => {
    // Check if className includes square brackets
    const bracketIndex = className.indexOf("[");
    if (bracketIndex !== -1) {
      const baseClass = className.slice(0, bracketIndex - 1);
      classMap[baseClass] = className;
    } else {
      const parts = className.split("-").filter(Boolean);
      if (parts.length === 1) {
        singleClasses += " " + parts[0];
      } else {
        const baseClass = parts.slice(0, parts.length - 1).join("-");
        classMap[baseClass] = className;
      }
    }
  });

  return singleClasses.trim() + " " + Object.values(classMap).join(" ");
};

// Scenarios Handled
/* 
1. single class = transform
2. Double class = translate-x-10, translate-y-10
3. triple class = object-left-top , object-left-bottom
4. array of classes = ['w-10','p-4'];
5. negative = -left-20, left-0
6. px-2,py-4,  -> p-2 //  to do
7. translate-x-[calc(50vw-50%)] -> translate-x
*/
